import { REGIONAL_PROD_ENVS, REGIONAL_PROD_SUBDOMAINS } from 'constants/envs';

const accessUrl: Record<string, string> = {
  prod: 'https://access.alta.avigilon.com/',
  dev: 'https://platinum.dev.alta.avigilon.com/',
  sandbox: 'https://platinum.sandbox.alta.avigilon.com/',
  mine: 'http://localhost:3000/',
};

REGIONAL_PROD_ENVS.forEach((env) => {
  accessUrl[env] =
    `https://access.${REGIONAL_PROD_SUBDOMAINS[env]}.alta.avigilon.com/`;
});

export const getAccessUrl = (region: string): string => {
  return accessUrl[region];
};
